import React from "react";
import { Row, Col, Typography, Divider } from "antd";
const { Title, Paragraph, Text } = Typography;

const Overview = () => {
  return (
    <Row type="flex">
      <Col span={20} offset={1}>
        <Title level={2}>Vendor Pre-Qualification Process Overview</Title>
        
        <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
          Welcome to the Vendor Pre-Qualification and Evaluation process! This portal 
          has been implemented to ensure contractors and vendors are capable of providing 
          the level of skill and quality of service and product required while maintaining 
          the highest standards in the industry.
        </Paragraph>

        <Divider />

        <Title level={4}>What is a Pre-Qualification Questionnaire (PQQ)?</Title>
        <Paragraph>
          A Pre-Qualification Questionnaire (PQQ) is a comprehensive document that vendors 
          must complete and submit to demonstrate their qualifications, capabilities, and 
          compliance with industry standards. All contractors, subcontractors, professional 
          service consultants, and suppliers seeking to do business must complete and submit 
          a PQQ through this portal.
        </Paragraph>

        <Title level={4}>The PQQ Process</Title>
        <Paragraph>
          The vendor pre-qualification process consists of three main steps:
        </Paragraph>
        <ol style={{ paddingLeft: '20px', marginBottom: '16px' }}>
          <li><Text strong>Complete Your i4 Vendor Profile:</Text> Fill out all required 
          information about your company, including financial data, safety records, and 
          organizational details.</li>
          <li><Text strong>Submit Payment:</Text> Pay the initial PQQ processing fee of $1,250. 
          This covers the initial pre-qualification process.</li>
          <li><Text strong>Attach and Certify Your PQQ:</Text> Link your completed profile to 
          a specific project and bid ID, then certify and submit your PQQ.</li>
        </ol>

        <Divider />

        <Title level={4}>Important Requirements</Title>
        <Paragraph>
          <Text strong>No bid will be considered without submission of a Pre-Qualification 
          Questionnaire (PQQ).</Text> The applicant firm agrees and hereby certifies that 
          each submission of the PQQ or any information regarding any change thereto, shall 
          act as a certification and guarantee by the applicant firm that all information 
          contained therein is accurate, current, and complete.
        </Paragraph>

        <Title level={4}>Updating Your PQQ</Title>
        <Paragraph>
          If any of the information within your submitted PQQ changes during the term of any 
          contract, you must submit notice of such changes within <Text strong>seven (7) days</Text> 
          of the change. Additionally, every firm must, with submission of any bid, submit a 
          Certification of No Change or notify of any changes to its previously submitted PQQ.
        </Paragraph>

        <Divider />

        <Title level={4}>Getting Started</Title>
        <Paragraph>
          To begin the process, navigate to your Dashboard and follow the step-by-step guides 
          available in the <Text strong>Guides</Text> section. For a complete list of required 
          documentation, please review the <Text strong>Required Documentation</Text> section.
        </Paragraph>

        <Paragraph style={{ marginTop: '24px', fontStyle: 'italic', color: '#666' }}>
          Need help? Visit the <Text strong>Support</Text> section for contact information, or 
          check out our detailed guides for step-by-step instructions.
        </Paragraph>
      </Col>
    </Row>
  );
};

export default Overview;
